import axios from "axios";
import { INotificationData } from "./interfaces";

export const getFormattedDate = (
  addYears = 0,
  subtractDays = 0,
  subtractMonths = 0,
) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + addYears);
  date.setDate(date.getDate() - subtractDays);
  date.setMonth(date.getMonth() - subtractMonths);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const sendNotification = (data: INotificationData) => {
  axios
    .post(`${process.env.REACT_APP_notificationApi}/notification`, data)
    .catch((err) => console.error(err));
};

export const fileToBase64 = (
  file: File,
): Promise<{
  base64: string;
  name: string;
  type: string;
}> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () =>
      resolve({
        base64: reader.result as string,
        name: file.name,
        type: file.type,
      });

    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = async (
  base64: string,
  fileName: string,
  mimeType: string,
): Promise<File> => {
  const res = await fetch(base64);
  const blob = await res.blob();

  return new File([blob], fileName, {
    type: mimeType,
  });
};

export const getVisibleTabs = (
  allTabs: any[],
  activeTab: string,
  limit: number,
) => {
  const baseTabs = allTabs.slice(0, limit);

  if (baseTabs.some((t) => t.id === activeTab)) {
    return baseTabs;
  }

  const activeTabData = allTabs.find((t) => t.id === activeTab);

  if (!activeTabData) return baseTabs;

  return [...baseTabs.slice(0, limit - 1), activeTabData];
};

export const truncateText = (text: string, limit = 12) => {
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};

export const stripHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
